// 编辑模式
export const MODE_TYPE = {
  ADD: 'add',
  EDIT: 'edit',
  COPY: 'copy',
}

// 编辑模式文案
export const MODE_TYPE_TEXT = {
  [MODE_TYPE.ADD]: '新增',
  [MODE_TYPE.EDIT]: '编辑',
  [MODE_TYPE.COPY]: '新增',
}

// 企业方案上下架状态（注意 ON=10 非 1）
export const ENTERPRISE_PLAN_STATUS = { ON: 10, OFF: 0 }

// 状态筛选项
export const ENTERPRISE_PLAN_STATUS_OPTIONS = [
  { label: '全部', value: '' },
  { label: '上架', value: 10 },
  { label: '下架', value: 0 },
]
